import { MicrophoneQuestionIcon } from './MicrophoneQuestionIcon';

/**
 * author: Michael Irigoyen
 * id C209FA9B-CE60-4CC6-853D-0180D05CDF93
 * name microphone-question
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-question.svg
 * tags
 * - Audio 
 * - Music 
 */
export const MicrophoneHelpIcon = MicrophoneQuestionIcon;
export default MicrophoneHelpIcon